export interface IApplicationHubMessage {
    entity: string;
    action: ApplicationHubMessageAction;
    payload: string | null;
}

export enum ApplicationHubMessageAction {
    Update = 0
}